export default "__VITE_ASSET__CFbE0pY9__"